import { render, staticRenderFns } from "./ShopScore.vue?vue&type=template&id=d136fb5a&scoped=true"
import script from "./ShopScore.vue?vue&type=script&lang=js"
export * from "./ShopScore.vue?vue&type=script&lang=js"
import style0 from "./ShopScore.vue?vue&type=style&index=0&id=d136fb5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d136fb5a",
  null
  
)

export default component.exports